module.exports = __webpack_public_path__ + "img/SketchPngef1fcf6c64498ba4303121d0c49c730ba261d78659ec1a219bfcce44e83492ee.2a89e5ae.png";